/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of Toy Hot New List
 * Alfapeople -Customisation object -For Toy HotNewList page
 */

import React, { Component } from 'react';

export interface IToy {
  toyImage?: string;
  toyDescription?: string;
  toyLink?: string;
}
/**
 *
 * HotNewList component
 * @extends Component
 */
export class HotNewList extends Component {
  private readonly toys: IToy[] = [
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDq1h',
      toyDescription: 'Little Tikes Cozy Truck',
      toyLink: '/online/cozy-truck/5637170644.p',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDsCq',
      toyDescription: 'Lego – Olaf Disney Frozen',
      toyLink: '/online/41169-olaf/5637326334.p',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqs',
      toyDescription: 'L.O.L. Surprise OMG Winter Disco ',
      toyLink: '/l-o-l-surprise-omg-winter-disco-asst/5637332077.p',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqt',
      toyDescription: 'Poppy’S Hot Air Balloon Adventure',
      toyLink: '/41252-poppy-s-hot-air-balloon-adventure/5637341879.p',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqu',
      toyDescription: 'Pop Pop Hair Surprise',
      toyLink: '/pop-pop-hair-surprise-3-in-1-pops-asst-in-sk/5637322167.p',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDxP4',
      toyDescription: 'Disney Frozen 2 Singing Elsa Fashion Doll',
      toyLink: '/singing-doll---elsa/5637315621.p',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1u',
      toyDescription: 'Poopsie Rainbow Surprise Slime Kit',
      toyLink: '/poopsie-chasmell-rainbow-slime-kit/5637326831.p',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-sm-12'>
            <h1 className='toy-heading'>hot and new</h1>
          </div>
          {this.toys.map((p) => (
            <div className='col-lg-4 col-md-6 col-sm-12'>
              <div className='row product-row'>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='img-link'>
                    <img
                      className='img-responsive'
                      src={p.toyImage}
                      alt={p.toyDescription}
                    />
                  </a>
                </div>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='toy-link'>
                    {p.toyDescription}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default HotNewList;
